export default function XML_Quiz() {
  return (
    <div>
      <h1>XML_Quiz</h1>
      <p>This is the XML_Quiz component.</p>
    </div>
  );
}